import React from "react";

const EstateContent = () => {
  return (
    <div className="my-16 mx-16 py-10 rounded-2xl text-center border">
      <div>
        <h3 className="mb-8 text-themeColor">Thailand real estate laws</h3>
      </div>
      <div
        className="my-20 text-medium font-medium"
        style={{ paddingLeft: "30px", paddingRight: "30px" }}
      >
        <p className="my-8">
          Thailand offers a range of real estate opportunities for both local
          and foreign investors. However, navigating the country's laws and
          regulations can be complex. That's why it's important to work with a
          professional and experienced real estate team that can guide you
          through the process. Our team is well-versed in Thailand's real estate
          laws and regulations, and we'll work with you to ensure that your
          property purchase or investment is compliant and secure. From due
          diligence and contract review to assistance with obtaining the
          necessary permits and licenses, we're here to help make your real
          estate experience in Thailand a success. Contact us today to learn
          more about how we can help you navigate Thailand's real estate laws
          and regulations.
        </p>
      </div>
    </div>
  );
};

export default EstateContent;
